import styled from '@emotion/styled'

export const StylePreviewWrapper = styled.div`
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 11111;
  width: 100%;
  height: 100%;
  oveflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyleImageWrapper = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
`

export const StyleImage = styled.img`
  height: 400px;
  border-radius: 8px;
`

export const StylePreviewAction = styled.button`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 0px;
  background: ${(props: any) => props.theme.colors.primary};
  color: ${(props: any) => props.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StylePreviewCloseAction = styled.button<any>`
  background: ${(props: any) => props.theme.colors[props?.bg || 'primary']};
  width: 40px;
  height: 40px;
  border: 0px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StylePreviewRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  position: absolute;
  top: 20px;
  right: 20px;
`
